import Permissions from '@/common/permissions';

export const UNAPPLIED_FUNDS_DASHBOARD_PERMISSIONS = [Permissions.VIEW_INVOICES, Permissions.VIEW_OMNI_BALANCES];
export const UNAPPLIED_FUNDS_BANKING_BALANCE_PERMISSIONS = [Permissions.VIEW_OMNI_BALANCES];
export const UNAPPLIED_FUNDS_INVOICING_PERMISSIONS = [Permissions.VIEW_INVOICES];

export const UNAPPLIED_FUNDS_HOME_BANNER_HEIGHT = '54px';
